<script setup lang="ts">
import LanguageMenu from './LanguageMenu.vue'
import RegionMenu from './RegionMenu.vue'
import UserMenu from './UserMenu.vue'
import { computed, onMounted, ref } from 'vue'
import NotificationContainer from '../notification/NotificationContainer.vue'

const url: URL = new URL(window.location.href)
const params: URLSearchParams = url.searchParams
const redirectAction: string | null = params.get('redirect_action')
const getStatus: string | null = params.get('status')
const newRegistration: string | null = params.get('new_registration')
const showLanguageSelectMenu = computed(() => window.showLanguageSelectMenuInHeader ?? false)
const keys = ref(['utm_source', 'utm_medium', 'utm_campaign', 'affiliate_id'])

onMounted(async () => {
    // utm params
    if (params.toString()) {
        params.forEach((value, key) => {
            if (keys.value.includes(key)) {
                document.cookie = `${key}=${value};expires=${new Date(
                    Date.now() + 7 * 24 * 60 * 60 * 1000
                ).toUTCString()};path=/`
            }
        })
    }

    const referral_code = window.findGetParameter('referral')

    if (referral_code) {
        window.createCookie('conda_referral_code', referral_code, 1440)
    }

    // Google and/or Jentis Tag Manager
    if (newRegistration) {
        window.dataLayer.push({
            event: 'Registration',
        })

        if (window._jts) {
            window._jts.push({
                track: 'registration',
            })
        }
    }
    // End Google and/or Jentis Tag Manager
})
</script>
<template>
    <RegionMenu />
    <NotificationContainer />
    <div class="register-login d-flex align-items-center small my-1 ml-auto mr-10 justify-end xl:mr-0">
        <UserMenu />
        <LanguageMenu v-if="showLanguageSelectMenu" />

        <div
            v-if="redirectAction === 'email-verification'"
            class="modal wrapper-fluid container-sm email-change-confirmation-modal"
            style="display: block">
            <div class="modal-body relative mx-auto my-5 bg-white">
                <!-- Modal Body -->
                <div class="modal-heading b-bottom border-gray-light bg-gray-lightest py-2 text-center">
                    <span class="icon ion-ios-email my-2"></span>
                </div>

                <div class="modal-content mx-auto px-4 py-4 text-center">
                    <h2 v-if="getStatus === 'already_verified'" class="max-w-sm">
                        {{ $t('email_verification_already_verified') }}
                    </h2>
                    <h2 v-else-if="getStatus === 'email_pending_missmatch'" class="max-w-sm">
                        {{ $t('email_verification_email_pending_missmatch') }}
                    </h2>
                    <h2 v-else-if="getStatus === 'expired_link'" class="max-w-sm">
                        {{ $t('email_verification_expired_link') }}
                    </h2>
                    <h2 v-else class="max-w-sm">
                        {{ $t('email_verification_verified') }}
                    </h2>
                </div>

                <div class="conda-create-company-account-buttons d-block mb-4 px-4 text-center">
                    <a class="i-btn i-btn-secondary i-btn-lg button-accept w100-xs text-white" href="#">{{
                        $t('Ok')
                    }}</a>
                </div>
            </div>
        </div>

        <div
            v-if="redirectAction === 'newsletter-confirmed'"
            class="modal wrapper-fluid container-sm email-change-confirmation-modal"
            style="display: block">
            <div class="modal-body relative mx-auto my-5 bg-white">
                <!-- Modal Body -->

                <div class="modal-heading b-bottom border-gray-light bg-gray-lightest py-2 text-center">
                    <span class="icon ion-ios-email my-2"></span>
                </div>

                <div class="modal-content mx-auto px-4 py-4 text-center">
                    <h2 v-if="getStatus == 'already_verified' || getStatus == 'already_decided'" class="max-w-sm">
                        {{ $t('email_verification_already_verified') }}
                    </h2>

                    <h2 v-if="getStatus == 'expired_link'" class="max-w-sm">
                        {{ $t('email_verification_expired_link') }}
                    </h2>

                    <h2 v-if="getStatus == 'success'" class="max-w-sm">
                        {{ $t('newsletter_verification_success') }}
                    </h2>
                </div>

                <div class="conda-create-company-account-buttons d-block mb-4 px-4 text-center">
                    <a class="i-btn i-btn-secondary i-btn-lg button-accept w100-xs text-white" href="#">{{
                        $t('Ok')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
